import { FC } from "react";
import { IApartmentArea } from "@wohnsinn/ws-ts-lib";
import ItemList, { TItemListItem } from "../ItemList";
import { useTranslation } from "react-i18next";
import styles from "component/organisms/ApartmentInformation/ApartmentInformation.module.scss";
import Headline, { HEADLINE_SIZE } from "component/atoms/typographie/Headline";

const ApartmentAreas: FC<{ areas: IApartmentArea }> = ({ areas }) => {
  const { t } = useTranslation("common");
  const { t: a } = useTranslation("common", { keyPrefix: "apartment.areas" });
  const items: TItemListItem[] = [];

  if (areas?.livingArea) {
    items.push({
      key: "livingArea,",
      label: a("livingArea.label"),
      value: areas?.livingArea + " " + t("qm"),
    });
  }

  if (items?.length) {
    return (
      <div className={styles.informationSection}>
        <Headline size={HEADLINE_SIZE.H3} tag={"span"}>
          {t("apartment.areas.areas")}
        </Headline>
        <ItemList items={items} />
      </div>
    );
  }
};

export default ApartmentAreas;
